export default {
  title: 'Actualizare orar!',
  labels: {
    old_time: 'Ora anterioară de ridicare:',
    new_time: 'Noua oră de ridicare:',
    old_serve_time: 'Ora de servire anterioară:',
    new_serve_time: 'Ora nouă de servire:',
  },
  buttons: {
    print: 'Tipărește și închide',
    got_it: 'Am înțeles',
  },
  feedback: {
    new_prep_time: 'Ora de livrare a fost actualizată. Ajustați programul de pregătire în consecință.',
  },
  toasts: {
    something_went_wrong: 'Ceva nu a funcționat, vă rugăm încercați din nou',
  },
};
